import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const StyledCardWrapper = styled.div`
  background: #fafafa;
  border-radius: 10px;
  padding: ${spacing.plusHalf};
  border: #c3c3c5;
`;
